var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.9496 7.7101L17.8096 7.6301L16.4196 6.8301L13.5496 5.1701C12.6696 4.6601 11.3296 4.6601 10.4496 5.1701L7.57961 6.8301L6.18961 7.6401L6.00961 7.7401C4.21961 8.9401 4.09961 9.1601 4.09961 11.0901V15.7001C4.09961 17.6301 4.21961 17.8501 6.04961 19.0801L10.4496 21.6201C10.8896 21.8801 11.4396 22.0001 11.9996 22.0001C12.5496 22.0001 13.1096 21.8801 13.5496 21.6201L17.9896 19.0501C19.7796 17.8501 19.8996 17.6301 19.8996 15.7001V11.0901C19.8996 9.1601 19.7796 8.9401 17.9496 7.7101Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18945 7.64L7.57945 6.83L10.3195 5.25L10.4495 5.17C11.3295 4.66 12.6695 4.66 13.5495 5.17L13.6795 5.25L16.4195 6.83L17.8095 7.63V5.49C17.8095 3.24 16.5695 2 14.3195 2H9.66945C7.41945 2 6.18945 3.24 6.18945 5.49V7.64Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8397 13.34L14.2197 14.1C14.1197 14.21 14.0497 14.43 14.0597 14.58L14.1197 15.56C14.1597 16.16 13.7297 16.47 13.1697 16.25L12.2597 15.89C12.1197 15.84 11.8797 15.84 11.7397 15.89L10.8297 16.25C10.2697 16.47 9.83975 16.16 9.87975 15.56L9.93975 14.58C9.94975 14.43 9.87975 14.21 9.77975 14.1L9.15975 13.34C8.76975 12.88 8.93975 12.37 9.51975 12.22L10.4697 11.98C10.6197 11.94 10.7997 11.8 10.8797 11.67L11.4097 10.85C11.7397 10.34 12.2597 10.34 12.5897 10.85L13.1197 11.67C13.1997 11.8 13.3797 11.94 13.5297 11.98L14.4797 12.22C15.0597 12.37 15.2297 12.88 14.8397 13.34Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.a69f6629503902fd2ec82ed299bffb55.svg";
export { ForwardRef as ReactComponent };